<template>
	<div id="scopes-selector">
		<v-menu :content-class="'account-menu--theme --app'" min-width="200" offset-y nudge-bottom="15">
			<template v-slot:activator="{ on, attrs }">
				<div class="histogram-type-label" v-bind="attrs" v-on="on">
					<span class="name">{{ activeScopeType.text }}</span>
					<i class="material-icons">expand_more</i>
				</div>
			</template>

			<div class="account-menu-content histogram-types-menu-content">
				<v-list>
					<v-list-item
						v-for="scope in scopeTypes"
						:key="scope.value"
						@click="onSelection(scope)"
						:class="{ '--selected': scope.value == activeScopeType.value }"
					>
						<span>{{ scope.text }}</span>
					</v-list-item>
				</v-list>
			</div>
		</v-menu>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	computed: {
        ...mapState("Scopes", ["activeScopeType", "scopeTypes"]),
	},

	methods: {
		onSelection(type) {
			window.lutify.scopes.selected = type.value;
            this.$store.dispatch("Scopes/setActiveScopeType", type);

			window.gpu.render();
		},
	},
};
</script>

<style lang="scss">
#scopes-selector {
	margin-right: auto;
}
</style>
